import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import moment from "moment";

function AppWebReportWorkDone(props) {

    let [agData, setAGData] = React.useState([{}])
    let [doneanmeldungDate, setDoneAnmeldungDate] = useState(null)
    let [donefreigabeDate, setDoneFreigabeDate] = useState(null)
    let [donefreigabeType, setDoneFreigabeType] = React.useState("")


    useEffect(async () => {
        if(props.doneData===undefined){
            setAGData([{}])
            setDoneAnmeldungDate(null)
            setDoneFreigabeDate(null)
            setDoneFreigabeType("")
        }
        else{
            setAGData(props.doneData)
            setDoneAnmeldungDate(moment(props.doneData[0].doneDate).format("YYYY-MM-DD"))
            setDoneFreigabeDate(moment(props.doneData[0].confirmationDate).format("YYYY-MM-DD"))
            setDoneFreigabeType(props.doneData[0].confirmationType)
        }
        }, [props.doneData]);


    function getWorkDoneAuftraggeberTableBody(auftraggeberData) {
                console.log(auftraggeberData,44444)

        return auftraggeberData?.map((item) => (<tr key={item.id}>
            <td>{item.firstName}</td>
            <td>{item.lastName}</td>
            <td>{item.role}</td></tr>))
    }

    return (<>
        <br/>
        <Row>
            <Col sm={6}>
                <table className="table handwai-white-text">
                    <thead>
                    <tr>
                        <th scope="col">Vorname</th>
                        <th scope="col">Nachname</th>
                        <th scope="col">Rolle</th>
                    </tr>
                    </thead>
                    <tbody>
                    {getWorkDoneAuftraggeberTableBody(agData)}
                    </tbody>
                </table>
            </Col>
            <Col sm={6}>
                <Row>
                    <label className="handwai-text-label-normal"> Abmeldung Versendet </label>
                    &nbsp;&nbsp;<input type="date"
                                       disabled={true}
                                       value={doneanmeldungDate}
                /> &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;

                    &nbsp; &nbsp;&nbsp;

                    <label className="handwai-text-label-normal"> Bestätigungsdatum </label>
                    &nbsp;&nbsp;
                    <input type="date"
                           disabled={true}
                           value={donefreigabeDate}
                           />
                    &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;


                    <label className="handwai-text-label-normal"> Bestätigungs per </label>
                    &nbsp;&nbsp;
                    <input type="text"
                        value={donefreigabeType}
                           disabled={true}
                    />


                </Row>
                <br/><br/>


            </Col>


        </Row>

    </>);
}

export default AppWebReportWorkDone;
